import React from 'react'
import { Typography } from 'antd'
import { stepsParams } from '../constants'
import { stepInProgress } from '../parcers'
import StepFragment from './StepFragment'

const StepDescription = ({ title, started, optimalStart, optimalEnd, ended, color, status, locale }) => {
  return (
    <div {...stepsParams.stepsDescription}>
      <Typography.Text {...stepsParams.stepTitle(started && color)}>{title}</Typography.Text>
      <br />
      <section className='step-description'>
        <article className='step-description-fragment'>
          {StepFragment({
            label: locale.start,
            content: started ? started : locale.onHold,
            inProgress: stepInProgress({ status })
          })}
          {StepFragment({
            label: locale.optimalStart,
            content: optimalStart,
            inProgress: stepInProgress({ status })
          })}
        </article>
        <article className='step-description-fragment secondary-fragment'>
          {StepFragment({
            label: locale.end,
            content: ended ? ended : started ? locale.inProgress : locale.onHold,
            inProgress: stepInProgress({ status })
          })}
          {StepFragment({
            label: locale.optimalEnd,
            content: optimalEnd,
            inProgress: stepInProgress({ status })
          })}
        </article>
      </section>
    </div>
  )
}

export default StepDescription
